export default "__VITE_ASSET__AcwXgJiU__"